import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import { useTranslation } from "react-i18next";
import { useForm } from "@tanstack/react-form";
import { Button, Form, Row } from "react-bootstrap";
import { settingsFormModel } from "../../domain/models/settingsFormModel";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import {
  getSettings,
  updateSettings,
  clear,
} from "../../infrastructure/slices/settingsMutateSlice";
import { useEffect } from "react";
import moment from "moment/moment";

export const SettingsMutateForm = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation("common");

  const { settings } = useAppSelector((state) => state.planningSettings);

  useEffect(() => {
    void dispatch(getSettings());

    return () => {
      dispatch(clear());
    };
  }, []);

  const form = useForm({
    defaultValues: settings as settingsFormModel,
    onSubmit: async ({ value }) => {
      await dispatch(updateSettings(value));
    },
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        void form.handleSubmit();
      }}
    >
      <Row>
        <Content md="6">
          <ContentHeader title={t("Public holidays")} className="mb-3" />

          <form.Field
            name="holidays"
            key="holidays"
            validators={{
              onChange({ value }) {
                if (value == undefined) {
                  return undefined;
                }

                const invalidHolidays =
                  value.split("\n").filter((item) => {
                    const date = moment(item, "DD-MM-YYYY");
                    return !date.isValid();
                  }) ?? [];

                if (invalidHolidays.length > 0) {
                  return t("Invalid date");
                }

                return undefined;
              },
            }}
          >
            {(field) => {
              return (
                <Form.Group className="mb-3">
                  <Form.Label>{t("Public holidays")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    id={field.name}
                    key={field.name}
                    name={field.name}
                    value={field.state.value || ""}
                    onChange={(e) => field.handleChange(e.target.value)}
                    rows={20}
                    isInvalid={field.state.meta.errors.length > 0}
                  />

                  {field.state.meta.errors ? (
                    <div className={"invalid-feedback d-block"}>
                      {field.state.meta.errors
                        .map((error) => t(error + ""))
                        .join(", ")}
                    </div>
                  ) : null}
                </Form.Group>
              );
            }}
          </form.Field>

          {form.state.errors ? (
            <div className={"invalid-feedback d-block"}>
              {form.state.errors.map((error) => t(error + "")).join(", ")}
            </div>
          ) : null}
        </Content>

        <Content md="6">
          <ContentHeader title={t("crud.manage.title")} className="mb-3" />
          <div className={"me-3"}>
            <Button onClick={() => void form.handleSubmit()}>
              {t(`Submit`)}
            </Button>
          </div>
        </Content>
      </Row>
    </form>
  );
};
